import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { generatePath, useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import AppRoutes from 'constants/AppRoutes';

import type ILaunchpadDiscoverNavigationState from '../interfaces/ILaunchpadDiscoverNavigationState';

export default function useDiscoverNavigation(selectedMapId?: string): () => void {
  const navigate = useNavigate();
  const { t } = useTranslation();

  return useCallback(() => {
    if (!selectedMapId) {
      toast.info(t('launchpad.mustCreateValueChain'));
      return;
    }

    navigate(
      generatePath(AppRoutes.companyMap, { valueChainMapId: selectedMapId }),
      {
        state: {
          launchpadDiscover: true,
        } satisfies ILaunchpadDiscoverNavigationState,
      },
    );
  }, [navigate, selectedMapId, t]);
}
